import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"

const OrderSummaryWrapper = styled.div`
  cursor: pointer;
  padding-bottom: ${padding.medium};
`

export default OrderSummaryWrapper
